<script setup lang="ts">
import SidebarMenu from "@/components/SidebarMenu.vue";
import AbsolutePageHeader from "@/components/headers/AbsolutePageHeader.vue";
import PageFooter from "@/components/PageFooter.vue";
import CalculatorSidebarItems from "@/components/sidebar/CalculatorSidebarItems.vue";
import pageBg from "@/assets/calculators/calculator_bg.webp";
import { withDefaults, defineProps, ref } from "vue";

withDefaults(defineProps<{ showBlogBtn?: boolean; showBgImage?: boolean }>(), {
  showBlogBtn: true,
  showBgImage: true,
});

const isMenuOpen = ref(false);
</script>

<template>
  <div class="flex xl:flex-row flex-col h-screen">
    <SidebarMenu
      :show-blog-btn="showBlogBtn"
      :is-menu-open="isMenuOpen"
      @toggle-menu="isMenuOpen = !isMenuOpen"
    >
      <CalculatorSidebarItems @close-menu="isMenuOpen = false" />
    </SidebarMenu>

    <main class="flex flex-col flex-1 relative overflow-hidden">
      <AbsolutePageHeader :show-blog-btn="true" class="hidden xl:flex" />
      <section
        class="flex-1 overflow-hidden bg-secondary bg-cover bg-center"
        :style="showBgImage ? { backgroundImage: `url(${pageBg})` } : {}"
      >
        <slot />
      </section>
      <PageFooter />
    </main>
  </div>
</template>
